import React from 'react';

const Tiktok = (props: object) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="0.8" clipPath="url(#clip0_10613_9001)">
        <path
          d="M12 0C5.37361 0 0 5.37361 0 12C0 18.6264 5.37361 24 12 24C18.6264 24 24 18.6264 24 12C24 5.37361 18.6264 0 12 0ZM18.0202 9.18155V10.8064C17.254 10.8067 16.5096 10.6565 15.8075 10.3603C15.356 10.1697 14.9354 9.92414 14.5507 9.62737L14.5622 14.6286C14.5574 15.7548 14.1119 16.8129 13.3055 17.6099C12.6492 18.2587 11.8177 18.6712 10.9163 18.8048C10.7046 18.8361 10.489 18.8522 10.2711 18.8522C9.30623 18.8522 8.39025 18.5396 7.64095 17.963C7.49995 17.8544 7.36509 17.7367 7.2367 17.6099C6.36277 16.7461 5.91211 15.5755 5.988 14.3439C6.04589 13.4065 6.42122 12.5124 7.04691 11.8117C7.87472 10.8844 9.03281 10.3697 10.2711 10.3697C10.489 10.3697 10.7046 10.3861 10.9163 10.4175V11.0182V12.6894C10.7155 12.6232 10.5011 12.5867 10.2778 12.5867C9.14648 12.5867 8.23125 13.5097 8.24817 14.6418C8.25891 15.3662 8.65458 15.9994 9.23817 16.3484C9.51244 16.5125 9.82795 16.6141 10.1647 16.6326C10.4285 16.647 10.6818 16.6103 10.9163 16.5329C11.7246 16.2659 12.3077 15.5067 12.3077 14.6113L12.3104 11.2622V5.14781H14.548C14.5501 5.36953 14.5726 5.58586 14.6145 5.79548C14.7833 6.64397 15.2616 7.38009 15.9272 7.88194C16.5076 8.3197 17.2304 8.5792 18.0137 8.5792C18.0142 8.5792 18.0207 8.5792 18.0201 8.57869V9.18155H18.0202Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_10613_9001">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Tiktok;
